import { FREE_SHIPPING_ROUTES } from './FreeShipping/freeShippingRoutes';
import { MARKETING_AUTOMATION_ROUTES } from './MarketingAutomation';
import { PROMOTIONS_ROUTES } from './Promotions';

export const MARKETING_ROUTES = {
  couponList: '/coupons',
  newCoupon: '/coupons/new',
  editCoupon: '/coupons/:id',
  marketingApps: '/marketing/apps',
  ...FREE_SHIPPING_ROUTES,
  ...PROMOTIONS_ROUTES,
  ...MARKETING_AUTOMATION_ROUTES,
};

export const DATE_TYPE_QUERY_PARAM = 'date_type';
export const DISCOUNT_OPTION_ID_QUERY_PARAM = 'discount_option_id';

export function buildUrl(
  path: string,
  params: Record<string, string | undefined>,
): string {
  const search = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      search.set(key, value);
    }
  });

  return `${path}?${search.toString()}`;
}
